import { createAction, props } from "@ngrx/store";
import { TestCase } from "../../models/testCase";

// Load Test Cases
const loadTestCases = createAction(
  '[Test Case] Load Test Cases',
  props<{ mappingId: string }>()
);

const loadTestCasesSuccess = createAction(
  '[Test Case] Load Test Cases Success',
  props<{ testCasesToSourceMapping: TestCase[] }>()
);

const loadTestCasesFailure = createAction(
  '[Test Case] Load Test Cases Failure',
  props<{ error: any }>()
);

// Create Mapping
const createMapping = createAction(
  '[Test Prioritization] Create Mapping',
  props<{ payload: any }>()
);

const createMappingSuccess = createAction(
  '[Test Prioritization] Create Mapping Success',
  props<{ response: any }>()
);

const createMappingFailure = createAction(
  '[Test Prioritization] Create Mapping Failure',
  props<{ error: any }>()
);

// Update Mapping Response
const updateMappingResponse = createAction(
  '[Test Prioritization] Update Mapping Response',
  props<{ mappingResponse: any }>()
);

// Update Mapping
const updateMapping = createAction(
  '[Test Prioritization] Update Mapping',
  props<{ payload: any }>()
);

const loadRecommendations = createAction(
  '[Test Case] Load Recommendations',
  props<{ mappingId: string }>()
);

const loadRecommendationsSuccess = createAction(
  '[Test Case] Load Recommendations Success',
  props<{ recommandations: any[] }>()
);

const loadRecommendationsFailure = createAction(
  '[Test Case] Load Recommendations Failure',
  props<{ error: any }>()
);

const clearStore = createAction("[TestPrioritization] Clear Store");

export const TestPrioritizationActions = {
  loadTestCases,
  loadTestCasesSuccess,
  loadTestCasesFailure,
  createMapping,
  createMappingSuccess,
  createMappingFailure,
  updateMappingResponse,
  updateMapping,
  loadRecommendations,
  loadRecommendationsSuccess,
  loadRecommendationsFailure,
  clearStore
};
